export default "__VITE_ASSET__CUti8cBJ__"